import { render, staticRenderFns } from "./AllTable.vue?vue&type=template&id=17bfb8f7&scoped=true&"
import script from "./AllTable.vue?vue&type=script&lang=js&"
export * from "./AllTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bfb8f7",
  null
  
)

export default component.exports